import { ReactElement } from 'react';

import { AddCircleIcon, ClearIcon, StyledFlex } from '@dreryk/react-components';

import { ICD10Code } from '../../../../shared/types';
import { MedicineSelectorIcd10Code } from '../medicineSelector.types';
import { sortMedicineSelectorIcd10Code } from '../medicineSelector.utils';

import { MedicineSelectorActionInputChip } from './MedicineSelectorActionInputChip';

const MAX_DISPLAYED_ICD10_CODES = 9;

type MedicineSelectorIcd10CodeChipsProps = {
   readonly onIcd10CodeSelect: (icd10Code: ICD10Code) => void;
   readonly onIcd10CodeDeselect: (icd10Code: ICD10Code) => void;
   readonly icd10Codes: MedicineSelectorIcd10Code[];
};

export const MedicineSelectorIcd10CodeChips = (props: MedicineSelectorIcd10CodeChipsProps): ReactElement => {
   return (
      <StyledFlex flexWrap={'wrap'} gap={'4px'}>
         {props.icd10Codes
            .sort(sortMedicineSelectorIcd10Code)
            .slice(0, MAX_DISPLAYED_ICD10_CODES)
            .map((selectorIcd10Code) => (
               <MedicineSelectorActionInputChip
                  key={selectorIcd10Code.icd10Code}
                  icon={selectorIcd10Code.selected ? <ClearIcon /> : <AddCircleIcon />}
                  onClick={selectorIcd10Code.selected ? props.onIcd10CodeDeselect : props.onIcd10CodeSelect}
                  icd10Code={selectorIcd10Code.icd10Code}
                  selected={selectorIcd10Code.selected}
               />
            ))}
      </StyledFlex>
   );
};
